import { getRoute } from "../client"
import type { ShopStateDto } from "../../shared/shopTypes"
export const shopListRoute = getRoute<ShopStateDto>("/api/shop")
